<template>
  <div class="loader" v-if="loading"></div>
  <div>
    <section class="expertises section-padding">
      <div class="add-padding hero-banner-ten">
        <div class="form">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-9 title mb-3">
                  <h2>FORMULAIRE DE CONTACT</h2>
                  <p class="fw-bold">Contactez-nous dès maintenant et parlons ensemble de votre
                    projet.
                  </p>
                </div>
                <div class="col-md-3 postionTopRight">
                  <a href="tel:0562471909">
                    <span class="contact tel-form">
                        <i class="fa-solid fa-phone"></i>&nbsp; 05 62 47 19 09
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-3">
            <div class="col-md-12 box-success mb-40" v-if="msgResponseSuccess">
              <p class="text-start">Votre email a bien été envoyé !</p>
            </div>
            <div class="col-md-12 box-error mb-40" v-if="msgResponseError">
              <p class="text-start"> {{ errorForm }} </p>
            </div>
            <div class="col-md-12">
              <form ref="form" @submit.prevent="submitForm">
                <div class="row mb-3">
                  <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Nom*" required
                           v-model="formData.nom">
                  </div>
                  <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Prénom*" required
                           v-model="formData.prenom">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Société (le cas échéant)"
                           v-model="formData.societe">
                  </div>
                  <div class="col-md-6 mb-3">
                    <input type="email" class="form-control" placeholder="E-mail*" required
                           v-model="formData.email">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6 mb-3">
                    <input type="tel" class="form-control" placeholder="Téléphone*" required
                           v-model="formData.telephone">
                  </div>
                  <div class="col-md-6 select-custom">
                    <select class="form-select" v-model="formData.statut">
                      <option selected disabled value="">Vous êtes...</option>
                      <option value="Salarié">Salarié</option>
                      <option value="Entreprise">Entreprise</option>
                      <option value="En recherche d'emploi">En recherche d'emploi</option>
                      <option value="Consultant/formateur">Consultant/formateur</option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Ville"
                           v-model="formData.ville">
                  </div>
                  <div class="col-md-6 select-custom">
                    <select class="form-select" v-model="formData.objet">
                      <option selected disabled value="">Objet de votre demande...</option>
                      <option value="bilan">Bilan de compétences ou d'orientation</option>
                      <option value="coaching">Coaching</option>
                      <option value="recrut">Recrutement et outplacement</option>
                      <option value="form-rh">Formations RH & Management</option>
                      <option value="accomp-rh">Accompagnement RH</option>
                      <option value="autre">Autre</option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                                        <textarea class="form-control" placeholder="Message...*"
                                                  v-model="formData.message" required></textarea>
                  </div>
                </div>
                <div class="form-check mb-3 text-i-do">
                  <input class="form-check-input" type="checkbox" id="accepter"
                         v-model="formData.accepter">
                  <label class="form-check-label" for="accepter">
                    En soumettant ce formulaire, j'accepte que les informations saisies soient
                    exploitées dans le cadre de ma demande.
                  </label>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div id="divRecaptcha">
                      <div id="recaptcha" class="g-recaptcha"
                           data-sitekey="6LecGm0pAAAAAMyqbcdwfTP_bhETHtarE0vlrX3l">
                      </div>
                    </div>
                    <div class="errors" v-if="errorsFormContact.includes('captcha')">Veuillez
                      valider le
                      captcha !</div>
                    <div class="errors" v-if="errorsFormContact.includes('captchaVerification')">
                      Erreur
                      de vérification du ReCaptcha, veuillez réessayer plus tard ou contactez le
                      support SVP !
                    </div>
                  </div>
                  <div class="col-md-6">
                    <button type="submit" class="contact">Envoyer ma demande <i
                        class="fa-solid fa-arrow-right"></i></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="icon-box-one">
          <i>
            <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="30.5" cy="30.8047" rx="30" ry="30" transform="rotate(90 30.5 30.8047)"
                       fill="#F4989D"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-two">
          <i>
            <svg width="99" height="87" viewBox="0 0 99 87" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M49.5 0.804688L98.8634 86.3047H0.136551L49.5 0.804688Z" fill="#FAB74B"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-three">
          <i>
            <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="47.2854" y="2.2189" width="64.1646" height="64.1646"
                    transform="rotate(45 47.2854 2.2189)" stroke="#a3d6f5" stroke-width="2" fill="#044B94"
                    fill-opacity="0.1"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-four">
          <i>
            <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21.5" cy="21.8047" r="21" transform="rotate(180 21.5 21.8047)" fill="#318EC7"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-five">
          <i>
            <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21.5" cy="21.8047" r="21" transform="rotate(180 21.5 21.8047)" fill="#318EC7"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-six">
          <i>
            <svg width="108" height="108" viewBox="0 0 108 108" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="54.3496" width="75.7239" height="75.7239"
                    transform="rotate(-45 0.5 54.3496)" fill="#F4989D"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-seven">
          <i>
            <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1.91421" y="29.2539" width="38.234" height="38.234"
                    transform="rotate(-45 1.91421 29.2539)" stroke="#a3d6f5" stroke-width="2" fill="#044B94"
                    fill-opacity="0.1"/>
            </svg>
          </i>
        </div>
        <div class="icon-box-eight">
          <i>
            <svg width="70" height="61" viewBox="0 0 70 61" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M35 0.804681L69.208 60.0547L0.792006 60.0547L35 0.804681Z" fill="#FAB74B"/>
            </svg>
          </i>
        </div>
      </div>
    </section>
  </div>
</template>


<script setup>

const errorsFormContact = ref([])

const msgResponseSuccess = ref(false);
const msgResponseError = ref(false);
const errorForm = ref("Erreur, merci de contacter admin@emciconseil.fr");

const form = ref(null);
const formData = ref({
  statut: '',
  objet: '',
  accepter: false,
});
const loading = ref(false);

let scriptTag;

onMounted(() => {
  setTimeout(() => {
    var divRecaptcha = document.getElementById("divRecaptcha")
    document.getElementById("recaptcha").remove();
    divRecaptcha.innerHTML = `<div id="recaptcha" class="g-recaptcha" data-sitekey="6LecGm0pAAAAAMyqbcdwfTP_bhETHtarE0vlrX3l"></div>`;
    scriptTag = document.createElement("script");
    scriptTag.setAttribute("src", "https://www.google.com/recaptcha/api.js");
    scriptTag.setAttribute("defer", "");
    scriptTag.setAttribute("async", "");
    document.body.appendChild(scriptTag);
  }, 1000)
})

onUnmounted(() => {
  if (scriptTag) {
    scriptTag.remove();
  }
})

const submitForm = async () => {
  loading.value = true;

  errorsFormContact.value = [];

  if (!form.value.checkValidity()) {
    form.value.reportValidity();
    msgResponseError.value = true;
    errorForm.value = "Validation incorrecte, merci de recharger la page et de remplir correctement les champs";
    setTimeout(() => {
      msgResponseError.value = false;
    }, 6000);
    loading.value = false;
    return;
  }
  loading.value = true;
  if (!grecaptcha.getResponse()) {
    errorsFormContact.value.push("captcha");
    msgResponseError.value = true;
    errorForm.value = "Validation recaptcha non disponible, merci de vérifier votre internet et de réactualiser la page";
    setTimeout(() => {
      msgResponseError.value = false;
    }, 6000);
    loading.value = false;
  } else {
    const token = grecaptcha.getResponse();
    const responseCaptcha = await $fetch('/api/verifyCaptcha', {
      method: 'POST',
      body: { response: token },
    });
    if (responseCaptcha.success === true && errorsFormContact.value.length === 0) {
      const msgBody = ref("");

      msgBody.value = `
            Sujet : DEMANDE D'INFORMATION<br/><br/>
            [EMCI] Vous avez un message depuis votre site web de la part de :<br /><br />
            ${formData.value.prenom} ${formData.value.nom}<br/>
            Email : ${formData.value.email} <br/>
            Téléphone: ${formData.value.telephone} <br/>
            <br />
            Message :<br/>
            ${formData.value.message} <br /><br />`;

      const submissionData = {
        pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872', //GBBU EMCI : EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872 - GBBU TEST VrPndaEzxehPS7f63ZEr8vVdK2HtGDfD
        pType: "web-contact",
        pFct: 'SetContact',
        pMsgLastname: formData.value.nom,
        pMsgFirstname: formData.value.prenom,
        pMsgCompany: formData.value.societe,
        pMsgEmail: formData.value.email,
        pMsgPhone: formData.value.telephone,
        pMsgCountry: formData.value.statut,
        pMsgCity: formData.value.ville,
        pMsgSubject: formData.value.objet,
        pMsgMessage: msgBody.value,
        pMsgInfosValidConditionUse: formData.value.accepter,
      };

      const response = await $fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submissionData),
      });
      if (response) {
        formData.value = {
          nom: '',
          prenom: '',
          societe: '',
          email: '',
          telephone: '',
          statut: '',
          ville: '',
          objet: '',
          message: '',
          accepter: false,
        };
        msgResponseSuccess.value = true;
        setTimeout(() => {
          msgResponseSuccess.value = false;
        }, 5000);
      }
      loading.value = false;
    } else {
      loading.value = false;
      errorsFormContact.value.push("captchaVerification");
      msgResponseError.value = true;
      errorForm.value = "Une erreur s'est produite durant votre requête, merci de rafraichir la page avant de réessayer";
      setTimeout(() => {
        msgResponseError.value = false;
      }, 6000);
    }
  }
};
</script>

<style scoped>
.box-success {
  background: #adebad;
  border-radius: 5px;
  padding: 25px;
}

.box-success p {
  color: #FFF;
  font-family: Inter;
}

#divRecaptcha {
  margin-bottom: 2vh;
}


.add-padding {
  padding: 0 22.5vw;
}

.postionTopRight {
  margin: 20px 0px;
}

/* Select custom */
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  flex: 1;
  padding: 0 .5em;
  color: #25233E ! important;
  cursor: pointer;
  font-size: 1em;
  font-family: 'Inter';
}

.form-select {
  font-size: 14px;
  color: #212529;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  padding: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-select option {
  font-size: 14px;
  color: #212529;
  background-color: #ffffff;
}

select::-ms-expand {
  display: none;
}

.select-custom {
  position: relative;
  display: flex;
  height: 2em;
  line-height: 3;
  overflow: hidden;
  border-radius: .25em;
}

.select-custom::after {
  content: '\25BC';
  position: absolute;
  top: 0px;
  right: 12px;
  border-radius: 0 5px 5px 0;
  padding: 0 1.2em;
  background: #318EC7;
  cursor: pointer;
  pointer-events: none;
  transition: .25s all ease;
  color: #FFF;
  font-size: 12px;
}

.select-custom:hover::after {
  color: #000;
}

option {
  color: #25233E
}


/*  */

.form {
  font-family: 'Inter';
}

.form-control:hover,
.form-select:hover,
.form-check-input:hover {
  border-color: #318EC7;
  /* Couleur de la bordure au survol */
}

.form-check-label:hover {
  color: #318EC7;
  /* Couleur du texte au survol */
}

.contact:hover {
  color: #318EC7;
  /* Couleur du lien au survol */
}

.title {
  text-align: left;
  color: var(--accent, #25233E);
  font-family: Nunito;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 111.5%;
  letter-spacing: -0.51px;
}

p,
.text-i-do {
  color: var(--accent, #25233E);
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 144%;
  letter-spacing: 0.72px;
}

.text-i-do {
  text-align: justify;
}

.tel-form {
  border-radius: 50px;
  border: 2px solid var(--tertiaire, #318EC7);
  background: transparent;
  color: #25233E !important;
  white-space: nowrap;
}


svg ellipse,
path,
circle,
rect {
  fill: #a3d6f5 !important;
}

.icon-box-one,
.icon-box-two,
.icon-box-three,
.icon-box-four,
.icon-box-five,
.icon-box-six,
.icon-box-seven,
.icon-box-eight {
  background: transparent;
}

.icon-box-one {
  left: 8%
}

.icon-box-two {
  left: -2%
}

.icon-box-three {
  left: 5%
}

.icon-box-four {
  left: 5%;
  margin-left: -24px;
  margin-bottom: 53px;
}

.icon-box-five {
  right: 10%;
  top: 0%;
}

.icon-box-six {
  right: -1%;
  top: 13%;
}

.icon-box-seven {
  right: 5%;
  top: 37%;
}

.icon-box-eight {
  right: 2%;
  bottom: -2%;
}


.section-padding {
  padding-bottom: 4rem;
}

.span-background-blue {
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
}

.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 10px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 75px;
  height: 75px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

iframe {
  margin-top: -147px !important;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .form {
    margin-left: 2%;
  }

  .add-padding {
    padding: 0 2.5vw;
  }
}

@media only screen and (max-width: 991px) {

  .icon-box-one,
  .icon-box-two,
  .icon-box-three,
  .icon-box-four,
  .icon-box-five,
  .icon-box-six,
  .icon-box-seven,
  .icon-box-eight {
    display: none;
  }

}
</style>